import RowOther from './RowOther';

export default RowOther;
